import React from "react";
import styled from "styled-components";
import ActiveFilter from "components/common/EntityFilters/ActiveFilter";
import { ROW_MIN_HEIGHT } from "components/common/EntityFilters/Constants";
const FilterGroup = styled.div`
  display: inline-flex;
  align-items: center;
  min-height: ${ROW_MIN_HEIGHT}px;
  gap: 3px;
  flex-wrap: wrap;
`;
const FilterGroupTitle = styled.div`
  margin-right: 3px;
`;
const ActiveFilters = ({ attributes, filters, filterValueRenderers, onDeleteFilter, onChangeFilter }) => /* @__PURE__ */ React.createElement(React.Fragment, null, filters.entrySeq().map(([attributeId, filterValues]) => {
  const attribute = attributes == null ? void 0 : attributes.find(({ id }) => id === attributeId);
  return /* @__PURE__ */ React.createElement(FilterGroup, { key: attributeId }, /* @__PURE__ */ React.createElement(FilterGroupTitle, null, attribute.title, ":"), filterValues.map((filter) => /* @__PURE__ */ React.createElement(
    ActiveFilter,
    {
      filter,
      allActiveFilters: filters,
      key: `${attribute.id}-${filter.value}`,
      attribute,
      filterValueRenderer: filterValueRenderers == null ? void 0 : filterValueRenderers[attributeId],
      onChangeFilter,
      onDeleteFilter
    }
  )));
}).toArray());
export default ActiveFilters;
